import {useLayoutEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectIsPWA} from '../state/selectors/global';
import uaUtils from '../utils/uaUtils';

const useIOSSafariFixes = () => {
    const isPWA = useSelector(selectIsPWA);

    useLayoutEffect(() => {
        if (uaUtils.checkIsIOSSafari26()) {
            applyViewportHeightFix(isPWA);
        }

        if (uaUtils.checkIsIOSSafari27()) {
            removeTranslucentStatusBar();
        }
    }, []);
};

// Fix for iOS 26+ viewport height issue in PWA and Safari
// Safari Bug: https://discussions.apple.com/thread/256138682
// StackOverflow: https://stackoverflow.com/questions/79753701
const applyViewportHeightFix = (isPWA) => {
    const isIOSSafari26_1 = uaUtils.checkIsIOSSafari26_1();

    if (isIOSSafari26_1) {
        // Fix for iOS 26.1 pwa fullscreen height issue
        // Safari Bug: https://bugs.webkit.org/show_bug.cgi?id=301994
        // Additional fix in the AppContainer component
        document.documentElement.style.height = '100dvh';
    } else {
        document.documentElement.style.height = isPWA ? '100lvh' : '100dvh';
    }

    document.documentElement.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.body.style.overflow = 'scroll';
};

// black-translucent makes iOS 27 blur the top of the PWA (strip in AppContainer). iOS reads it on Add to Home Screen,
// so already installed PWAs keep it until re-added.
// Safari Bug: https://bugs.webkit.org/show_bug.cgi?id=325807
const removeTranslucentStatusBar = () => {
    document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')?.remove();
};

export default useIOSSafariFixes;
